import { ResourceBlockType } from '@mews-commander/data-access';
import { LocalizedEnum } from '@mews/framework';

interface ResourceTypeProps {
    type: ResourceBlockType;
}

export const ResourceType = ({ type }: ResourceTypeProps) => <LocalizedEnum prefix="ResourceBlockType" value={type} />;
